
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.75 13.366a9.072 9.072 0 00-5.495-2.89.98.98 0 01-.872-.98V1.611A.98.98 0 012.5.64 9.11 9.11 0 017.75 3.5v9.865zM7.75 13.366a9.072 9.072 0 015.495-2.89.98.98 0 00.872-.98V1.611a.978.978 0 00-1.116-.97A9.11 9.11 0 007.75 3.5v9.865z","stroke":"#fff","stroke-width":".98","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    